const colors = {
  primaryMain: 'var(--primary-main)',
  primaryLight: 'var(--primary-light)',
  primaryDark: 'var(--primary-dark)',
  primaryContrastText: 'var(--primary-contrast-text)',

  secondaryMain: 'var(--secondary-main)',
  secondaryLight: 'var(--secondary-light)',
  secondaryDark: 'var(--secondary-dark)',
  secondaryContrastText: 'var(--secondary-contrast-text)',

  successMain: 'var(--success-main)',
  successLight: 'var(--success-light)',
  successDark: 'var(--success-dark)',
  successContrastText: 'var(--success-contrast-text)',

  infoMain: 'var(--info-main)',
  infoLight: 'var(--info-light)',
  infoDark: 'var(--info-dark)',
  infoContrastText: 'var(--info-contrast-text)',

  warningMain: 'var(--warning-main)',
  warningLight: 'var(--warning-light)',
  warningDark: 'var(--warning-dark)',
  warningContrastText: 'var(--warning-contrast-text)',

  errorMain: 'var(--error-main)',
  errorLight: 'var(--error-light)',
  errorDark: 'var(--error-dark)',
  errorContrastText: 'var(--error-contrast-text)',

  textPrimary: 'var(--text-primary)',
  textSecondary: 'var(--text-secondary)',
  textDisabled: 'var(--text-disabled)',

  grey50: 'var(--grey50)',
  grey100: 'var(--grey100)',
  grey200: 'var(--grey200)',
  grey300: 'var(--grey300)',
  grey400: 'var(--grey400)',
  grey500: 'var(--grey500)',
  grey600: 'var(--grey600)',
  grey700: 'var(--grey700)',
  grey800: 'var(--grey800)',
  grey900: 'var(--grey900)',
  greyA100: 'var(--grey-a100)',
  greyA200: 'var(--grey-a200)',
  greyA400: 'var(--grey-a400)',
  greyA700: 'var(--grey-a700)',
  white: 'var(--white)',
} as const;

export default colors;
